"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79972],{

/***/ 79972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WhyUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function WhyUs() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-center mt-14 font-bold text-xl md:text-3xl text-[#2A4A63]",
                children: "What Is the Camp Lejeune Lawsuit?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-3 text-sm lg:text-base sm:text-center leading-8 max-w-[957px] mx-auto font-light",
                children: "The Camp Lejeune lawsuit aims to give money to people who lived or worked at the Marine Corps base in North Carolina between 1953 and 1987 and were exposed to toxic water. The contamination affected over a million people and resulted in illnesses such as cancer and birth defects. The lawsuit wants to hold the government accountable for not doing enough and compensate those who have been hurt."
            })
        ]
    });
}


/***/ })

}]);